import type { PublicPlanPrice } from '@/types/billing';

export function indexPublicPlanPrices(
  prices: PublicPlanPrice[],
): Record<'basic' | 'pro', PublicPlanPrice> {
  const indexed = Object.fromEntries(prices.map((price) => [price.plan_slug, price])) as Partial<
    Record<'basic' | 'pro', PublicPlanPrice>
  >;
  if (!indexed.basic || !indexed.pro) {
    throw new Error('Публичные цены тарифов должны содержать basic и pro');
  }
  return {
    basic: indexed.basic,
    pro: indexed.pro,
  };
}

export function formatPublicPlanPrice(price: PublicPlanPrice): string {
  return formatPublicMoneyFromCents(price.amount_cents, price.currency);
}

export function formatPublicMoneyFromCents(amountCents: number, currency: string): string {
  const normalizedCurrency = currency.toUpperCase();
  const amount = amountCents / 100;
  const formatter = new Intl.NumberFormat(normalizedCurrency === 'USD' ? 'en-US' : 'ru-RU', {
    style: 'currency',
    currency: normalizedCurrency,
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 2,
    maximumFractionDigits: 2,
  });
  return formatter.format(amount).replace(/\u00A0/g, ' ');
}

export function formatPublicDecimalAmount(amount: number, currency: string): string {
  const normalizedCurrency = currency.toUpperCase();
  const formatter = new Intl.NumberFormat(normalizedCurrency === 'USD' ? 'en-US' : 'ru-RU', {
    style: 'currency',
    currency: normalizedCurrency,
    minimumFractionDigits: Number.isInteger(amount) ? 0 : 1,
    maximumFractionDigits: 2,
  });
  return formatter.format(amount).replace(/\u00A0/g, ' ');
}

export function formatPublicPlanCadence(price: PublicPlanPrice): string {
  if (price.interval === 'month' && price.interval_count === 1) {
    return 'каждый месяц';
  }
  return `каждые ${price.interval_count} ${price.interval}`;
}

export function formatPublicPlanOverage(price: PublicPlanPrice): string {
  return `${formatPublicDecimalAmount(price.overage_price, price.currency)} за запрос`;
}

export function formatPublicIncludedUnits(units: number): string {
  return `${units.toLocaleString('ru-RU')} запросов / месяц`;
}
